import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { User } from '../types'
// Removed legacy managers in favor of unified Site Management
import SiteManagement from './admin/SiteManagement'
import MapLinksManager from './admin/MapLinksManager'
import LogsManager from './admin/LogsManager'
import UsersManager from './admin/UsersManager'
import TaskDashboard from './TaskDashboard'

interface AdminDashboardProps {
  user: User
}

function AdminDashboard({ user }: AdminDashboardProps) {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div>
      <div style={{ marginBottom: '1rem' }}>
        <button 
          className="btn" 
          onClick={() => navigate('/app')}
        >
          ← Back to User View
        </button>
      </div>

      <div className="admin-nav">
        <button 
          className={`btn ${location.pathname === '/admin/site-management' ? 'active' : ''}`}
          onClick={() => navigate('/admin/site-management')}
        >
          Site Management
        </button>
        <button 
          className={`btn ${location.pathname === '/admin/map-links' ? 'active' : ''}`}
          onClick={() => navigate('/admin/map-links')}
        >
          Map Links
        </button>
        <button 
          className={`btn ${location.pathname === '/admin/logs' ? 'active' : ''}`}
          onClick={() => navigate('/admin/logs')}
        >
          Activity Logs
        </button>
        <button 
          className={`btn ${location.pathname === '/admin/users' ? 'active' : ''}`}
          onClick={() => navigate('/admin/users')}
        >
          Users
        </button>
        <button 
          className={`btn ${location.pathname === '/admin/tasks' ? 'active' : ''}`}
          onClick={() => navigate('/admin/tasks')}
        >
          Tasks
        </button>
      </div>

      <Routes>
        <Route path="/" element={<Navigate to="/admin/sites" replace />} />
        <Route path="/site-management" element={<SiteManagement />} />
        <Route path="/map-links" element={<MapLinksManager />} />
        <Route path="/logs" element={<LogsManager />} />
        <Route path="/users" element={<UsersManager />} />
        <Route path="/tasks" element={<TaskDashboard user={user} />} />
        <Route path="*" element={<Navigate to="/admin/sites" replace />} />
      </Routes>
    </div>
  )
}

export default AdminDashboard
